import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../../elementos/basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";
import InfoNiveles from "../../elementos/basicos/InfoNiveles";
import { fetchEditarCurso, fetchObtenerCurso } from '../../../peticiones_API/PeticionesCursoConvocatoria';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidationForm';
import { DatosCorrectos, ServerNoCreoCurso, ServerUrlAFExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { useParams } from "react-router-dom";
import VisorPdf from '../eventos/herramientas_previsualizacion/VisorPdf';
import { ToastContainer, toast } from "react-toastify";

const FormEditarCurso = ({ proveedores, categorias, requisitos, setCategoriaSelect, subcategorias }) => {

    const { Id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;
    const [previsualizacionTemarioPdf, setPrevisualizacionTemarioPdf] = useState(null);
    const [previsualizacionAnexoPdf, setPrevisualizacionAnexoPdf] = useState(null);
    const [eliminado, setEliminado] = useState(false);


    const [formData, setFormData] = useState({
        IdCurso: '',
        nombre: '',
        url: '',
        nombreImg: null,
        AF: null,
        Proveedor: null,
        subcategoriaId: null,
        horas: null,
        temario_url: '',
        anexo_url: '',
        temario_pdf: '',
        anexo_pdf: '',
        pdfAnexoAnterior: null,
        nombreTemario: '',
        nombreAnexo: '',
        activo: false,
        plazasAgotadas: false,
        plazasMax: 0,
        plazasMin: 0,
        numPlazas: 0,
        nivel: null,
        id_categoria: null,
        tipo: "Convocatoria",
        vistaAdjuntos: "0",
        rutaImgVieja: "",
        descripcion: ''
    });

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        AF: "Debes insertar el numero de referencia",
        Proveedor: "Debes seleccionar un proveedor",
        id_categoria: "Debes seleccionar una categoria",
        subcategoriaId: "Debes seleccionar una subcategoría",
        horas: "Debes insertar el numero de horas de curso",
        temario_pdf: "Debes insertar un pdf de temario",
        temario_url: "Debes insertar una url de temario",
        anexo_url: "Debes insertar una url de anexo",
        nivel: "Debes seleccionar un nivel",
        anexo_pdf: "Debes insertar un pdf de anexo",
        nombreImg: "Debes insertar una imagen de portada"
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        AF: null,
        Proveedor: null,
        id_categoria: null,
        subcategoriaId: null,
        horas: null,
        nivel: null,
        nombreImg: null

    });


    const [categoriaHabilitado, setCategoriaHabilitado] = useState({
        tieneSub: false,
        anexo_url: false,
        anexo_pdf: false,
        nivel: false
    })

    // console.log("categoriaHabilitado", categoriaHabilitado);

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        cursoDuplicado: null,
        refDuplicado: null

    });

     const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);
        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, categoriaHabilitado, setEstadosActualizados);



    };

    useEffect(() => {
        async function fechtPrincipal() {
            try {

                const curso = await fetchObtenerCurso(Id);

                console.log("listado", curso);

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IdCurso: curso.Id,
                    nombre: curso.nombre,
                    AF: curso.AF,
                    Proveedor: curso.Proveedor,
                    id_categoria: curso?.Categoria?.[0]?.Id || null,
                    subcategoriaId: curso?.subcategoriaId,
                    horas: curso.horas,
                    plazasMin: curso.plazasMin,
                    plazasMax: curso.plazasMax,
                    plazasAgotadas: curso.plazasAgotadas,
                    numPlazas: curso.numPlazas,
                    activo: curso.activo,
                    anexo_url: curso.anexo?.endsWith("_anexo_pdf") ? "" : curso.anexo,
                    anexo_pdf: curso.anexo?.endsWith("_anexo_pdf") ? curso?.anexo : "",
                    pdfAnexoAnterior: curso.anexo?.endsWith("_anexo_pdf") ? curso?.anexo : "",
                    temario_url: curso.temario?.endsWith("_temario_pdf") ? "" : curso.temario,
                    url: curso.url,
                    nombreImg: curso.nombreImg,
                    nivel: curso.nivel,
                    tipo: curso.tipo,
                    descripcion: curso.descripcion,
                    vistaAdjuntos: curso.temario?.endsWith("_temario_pdf") ? "1" : "0", //Verificar si el temario termina con pdf.
                    pdfAnterior: curso.temario?.endsWith("_temario_pdf") ? curso?.temario : "", //Si existe el temario de un pdf
                }));

                if (curso?.Categoria?.[0]?.Id) {
                    const categoriaId = curso?.Categoria?.[0]?.Id;
                    const categoriaSeleccionada = categorias.find(cat => cat.Id == categoriaId);

                    if (categoriaSeleccionada) {
                        setCategoriaHabilitado({
                            anexo_pdf: categoriaSeleccionada.anexo,
                            anexo_url: categoriaSeleccionada.anexo,
                            nivel: categoriaSeleccionada.nivel,
                            tieneSub: categoriaSeleccionada.subcategoria
                        });
                    }
                }

                const campos = [
                    'nombre', 'AF', 'Proveedor', 'horas', 'id_categoria', 'temario_url', 'nivel', 'subcategoriaId', 'nombreImg'
                ];

                campos.forEach(campo => {
                    // console.log(`curso[${campo}]:`, curso[campo]); 

                    if (curso[campo] != null) {
                        setEstadoCampoReque(prevState => ({
                            ...prevState,
                            [campo]: false
                        }));
                    }
                });

                if (curso?.Categoria?.[0]?.Id != null) {
                    setEstadoCampoReque(prevState => ({
                        ...prevState,
                        ['id_categoria']: false
                    }));

                    function categoriaFuncion(value) {
                        const item = categorias.find(obj => obj.Id == value);
                        return item ? item.urlCat : null;
                    }
                    const urlCat = categoriaFuncion(curso?.Categoria?.[0]?.Id);

                    setCategoriaSelect(urlCat);

                }


                if (curso?.Categoria?.[0]?.Id != null) {
                    setEstadoCampoReque(prevState => ({
                        ...prevState,
                        ['subcategoriaId']: false
                    }));


                }

                //setPrevisualizacionTemarioPdf(curso.temario ? `${API_URL}/${curso.temario}` : '');
                //setPrevisualizacionAnexoPdf(curso.anexo ? curso.anexo : '');
                const url = curso.url;
                const parts = url.split('/');
                parts.pop();
                const newUrl = parts.join('/');
                if (/[áéíóúÁÉÍÓÚ]/.test(newUrl)) {
                    newUrl = newUrl.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                }
                console.log(newUrl);


                const urlPrevisualizacion = `${curso.img}`;

                
                setFormData(prevFormData => ({ ...prevFormData, rutaImgVieja: urlPrevisualizacion }));
                setPrevisualizacionImg(`${curso.img}`|| null);
                
                if(curso.pdf){
                    setPrevisualizacionTemarioPdf(`${curso.pdf}`|| null)
                }

                if(curso.pdfAnexo){
                    setPrevisualizacionAnexoPdf(`${curso.pdfAnexo}`|| null)
                }

                // setcategorias(listadoResponse.Categoria);
                // setProveedores(listadoResponse.Proveedores);
                // setRequisitos(listadoResponse.Requisito);



            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }
        fechtPrincipal();
    }, []);

    const asignarNombre = (file, name) => {
        let valorImg = document.getElementById("curso_img").value;
        let valorTemario = document.getElementById("temario_pdf")?.value; 
        let valorAnexo = document?.getElementById("anexo_pdf")?.value;
        const f = new Date();
        const dia = ('0' + f.getDate()).slice(-2);
        const mes = ('0' + (f.getMonth() + 1)).slice(-2);
        const año = f.getFullYear();
        const hora = ('0' + f.getHours()).slice(-2);
        const minutos = ('0' + f.getMinutes()).slice(-2);
        const segundos = ('0' + f.getSeconds()).slice(-2);

        const normalizarTexto = (texto) => {
                return texto
                    .toLowerCase() 
                    .normalize("NFD") 
                    .replace(/[\u0300-\u036f]/g, "") 
                    .replace(/\s+/g, "-");
        };

        if (valorImg != '' && name === 'curso_img') {

            //const nombreCursoNormalizado = normalizarTexto(file?.name);
            
            const nombreImg = `${dia}${mes}${año}${hora}${minutos}${segundos}_curso_img`;

            setFormData(prevFormData => ({ ...prevFormData, nombreImg: nombreImg }));
        }

        if (valorTemario != '' && name === 'temario_pdf') {
            //const nombreTemarioNormalizado = normalizarTexto(file?.name);

            const nombreTemario = `${dia}${mes}${año}${hora}${minutos}${segundos}_temario_pdf`;
            console.log('Nombre Temario:' + nombreTemario)
            setFormData(prevFormData => ({ ...prevFormData, nombreTemario: nombreTemario, temario_url: '' }));
        }

        if (valorAnexo != '' && name === 'anexo_pdf') {

            //const nombreAnexoNormalizado = normalizarTexto(file?.name);

            const nombreAnexo = `${dia}${mes}${año}${hora}${minutos}${segundos}_anexo_pdf`;
            console.log('Nombre Anexo:' + nombreAnexo) 
            setFormData(prevFormData => ({ ...prevFormData, nombreAnexo: nombreAnexo, anexo_url: ''}));
        }

    }


    useEffect(() => {


        if (estadosActualizados) {
            if (!eliminado) {
                const rutaBaseVieja = formData?.rutaImgVieja?.substring(0, formData?.rutaImgVieja?.lastIndexOf('/'));


                if (formData.url === rutaBaseVieja.replace("/img/cursos", "")) {
                    formData.rutaImgVieja = "";
                }
            }


            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    console.log("Simulacion editar curso");
                    //Lo metemos dentro de un async para que pueda exitir un await
                    try {

                        const response = await fetchEditarCurso(formData);


                    } catch (error) {
                        //console.log(error.response.data.error);

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'curso repetido error') {

                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, cursoDuplicado: true }));


                        }

                        if (error?.response?.data?.error == 'Url y AF repetida') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, refDuplicado: true }))
                        }
                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque]);





    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);

    const handleChange = (event) => {

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value, type, files, checked } = event.target;

        let newValue;
        let URLPrincipal = '';
        if (type === 'file') {
            newValue = files[0];
        } else if (type === 'checkbox') {
            newValue = checked;
        } else if (name === 'numPlazas' || name === 'horas' || name === 'nivel' || name === 'subcategoriaId' || name === 'Proveedor' || name === 'id_categoria') {
            newValue = value !== '' ? parseInt(value) : null;
            console.log(value)


        }
        else {
            newValue = value;
        }



        function gestionCaTSubcat(name, value, currentFormData) {
            let URLPrincipal = null;
        
            if (name === 'subcategoriaId') {
                const item = subcategorias.find(obj => obj.Id == value);
                if (item) {
                    URLPrincipal = item.url;
                    
                   
                    if (formData.id_categoria) {
                        const itemCat = categorias.find(obj => obj.Id == formData.id_categoria);
                        let URLSubcat = item.url.split("/").pop();
                        URLPrincipal = `${itemCat.urlCat}/${URLSubcat}`;
                    }
                } else {
                    setEstadoCampoReque(prevEstadoCampoReque => ({ ...prevEstadoCampoReque, subcategoriaId: false }));
                    setFormData(prevFormData => ({ ...prevFormData, subcategoriaId: null }));
                }
            }
            
            if (name === 'id_categoria') {
                const categoriaItem = categorias.find(obj => obj.Id == value);
                if (categoriaItem) {
                    URLPrincipal = categoriaItem.urlCat;
                    let anexo = categoriaItem.anexo;
                    let nivel = categoriaItem.nivel;
                    let tieneSub = categoriaItem.subcategoria;
        
                    setCategoriaHabilitado(prevFormData => ({ ...prevFormData, anexo_pdf: anexo, nivel: nivel, tieneSub: tieneSub }));
                    
                    if (anexo === false) {
                        setEstadoCampoReque(prevEstadoCampoReque => ({ ...prevEstadoCampoReque, anexo_pdf: false }));
                        setFormData(prevFormData => ({ ...prevFormData, anexo_pdf: null, anexo_url: '' }));
                    }
                    if (nivel === false) {
                        setEstadoCampoReque(prevEstadoCampoReque => ({ ...prevEstadoCampoReque, nivel: false }));
                        setFormData(prevFormData => ({ ...prevFormData, nivel: 0 }));
                    }
                    if (tieneSub === false) {
                        setEstadoCampoReque(prevEstadoCampoReque => ({ ...prevEstadoCampoReque, subcategoriaId: false }));
                        setFormData(prevFormData => ({ ...prevFormData, subcategoriaId: null }));
                    }
                    
                    
                    if (currentFormData?.subcategoriaId) {
                        const itemSubcat = subcategorias.find(obj => obj.Id == currentFormData.subcategoriaId);
                        let URLSubcat = itemSubcat.url.split("/").pop();
                        URLPrincipal = `${categoriaItem.urlCat}/${URLSubcat}`;
                    }
                } else {
                    setEstadoCampoReque(prevEstadoCampoReque => ({ ...prevEstadoCampoReque, id_categoria: false }));
                }
            }
        
            return URLPrincipal;
        }

        URLPrincipal = gestionCaTSubcat(name, value);
        if (URLPrincipal !== null) {
            const urlCompleta = "/" + URLPrincipal + "/" + (name === 'nombre' ? value : formData.nombre.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").toLowerCase() );
            setFormData(prevFormData => ({ ...prevFormData, url: urlCompleta }));

            
        }


        if (name === 'temario_url'){
            setFormData(prevFormData => ({ ...prevFormData, nombreTemario: '', nombreAnexo:'' }));
        }

        if (name === 'anexo_url'){
            setFormData(prevFormData => ({ ...prevFormData, nombreAnexo: '', nombreTemario:'' }));
        }


        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();
            
            if (name === 'curso_img') {
                asignarNombre(file, name);
                reader.onloadend = () => {
                    setPrevisualizacionImg(reader.result);
                };
                reader.readAsDataURL(file);
            }
            if (name === 'temario_pdf') {
                asignarNombre(file, name);
                reader.onloadend = () => {
                    setPrevisualizacionTemarioPdf(reader.result);
                };
                reader.readAsDataURL(file);
            }
            if (name === 'anexo_pdf') {
                asignarNombre(file, name);
                reader.onloadend = () => {
                    setPrevisualizacionAnexoPdf(reader.result);
                };
                reader.readAsDataURL(file);
            }

        }

        function categoriaFuncion(value) {
            const item = categorias.find(obj => obj.Id == value);
            return item ? item.urlCat : null;
        }
        const urlCat = categoriaFuncion(value);
        if (name == 'id_categoria') {
            setCategoriaSelect(urlCat);
        }

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }


    };

    const handleDelete = () => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        setEliminado(true);
        setPrevisualizacionImg(null);
    
        // Resetear el input de tipo file correctamente
        const fileInput = document.getElementById("curso_img");
        if (fileInput) {
            fileInput.value = ""; 
        }
    
        setFormData(prevFormData => {
            const nuevoFormData = { ...prevFormData, nombreImg: null };
            return nuevoFormData;
        });
    };
    


    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="EDITAR UN CURSO"
                        convocatoria="true"
                    />
                </CabeceraForm>

                <Container>
                    <ToastContainer />
                    <Col>

                        <Row md="3" >
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type="name" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>AF <span>*</span></TituloCategoria>
                                <Form.Control type="name" name="AF" value={formData.AF || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.AF} estadoAlerta={estadoCampoReque.AF} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria id="Proveedor">Proveedor <span>*</span></TituloCategoria>
                                <Form.Select value={formData.Proveedor || ''} name="Proveedor" onChange={handleChange}>
                                    <option value=""></option>
                                    {proveedores.map((proveedor) => (
                                        <option key={proveedor.Id} value={proveedor.Id}>
                                            {proveedor.nombre}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.Proveedor} estadoAlerta={estadoCampoReque.Proveedor} />
                            </Form.Group>


                        </Row>





                        <Row md="4">

                            <Form.Group className="mb-12">
                                <TituloCategoria>Categoria <span>*</span></TituloCategoria>
                                <Form.Select value={formData.id_categoria || ''} name="id_categoria" onChange={handleChange}>
                                    <option value=""></option>
                                    {categorias.map((categoria) => (
                                        <option key={categoria.Id} value={categoria.Id}>
                                            {categoria.categoria}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.id_categoria} estadoAlerta={estadoCampoReque.id_categoria} />
                            </Form.Group>

                            <Col md={1}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria>Horas <span>*</span></TituloCategoria>
                                    <Form.Control type="number" name="horas" value={formData.horas || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.horas} estadoAlerta={estadoCampoReque.horas} />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria id="subcategoria">Subcategoria <span>*</span></TituloCategoria>
                                    <Form.Select disabled={!categoriaHabilitado.tieneSub} value={formData.subcategoriaId || ''} name="subcategoriaId" onChange={handleChange}>
                                        <option value=""></option>
                                        {subcategorias.length === 0 ? (
                                            <option value="">No hay subcategorías disponibles</option>
                                        ) : (
                                            subcategorias.map((subcategoria) => (
                                                <option key={subcategoria.Id} value={subcategoria.Id}>
                                                    {subcategoria.nombre}
                                                </option>
                                            ))
                                        )}
                                    </Form.Select>
                                    <ErrorForm mensaje={camposRequeridos.subcategoriaId} estadoAlerta={estadoCampoReque.subcategoriaId} />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria id="nivel">Nivel <span>*</span></TituloCategoria>
                                    <Form.Select disabled={!categoriaHabilitado.nivel} value={formData.nivel || ''} name="nivel" onChange={handleChange}>
                                        <option value=""></option>
                                        {requisitos.map((requisito) => (
                                            <option key={requisito.Id} value={requisito.Id}>
                                                {requisito.Id}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <ErrorForm mensaje={camposRequeridos.nivel} estadoAlerta={estadoCampoReque.nivel} />
                                </Form.Group>
                            </Col>

                        </Row>

                    </Col>
                    <Col>
                        <Row md="3" >

                            <Col md={4}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria>Descripción Nivel</TituloCategoria>
                                    <Form.Control
                                        type="name"
                                        name="descripcion"
                                        value={formData.descripcion || ''}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={1}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria id="PlazasMinimas">Plazas Mín</TituloCategoria>
                                    <Form.Control type="number" name="plazasMin" value={formData.plazasMin || ''} onChange={handleChange} />
                                </Form.Group>
                            </Col>



                            <Col md={1}>
                                <Form.Group className="mb-12">
                                    <TituloCategoria id="PlazasMaximas">Plazas Máx</TituloCategoria>
                                    <Form.Control type="number" name="plazasMax" value={formData.plazasMax || ''} onChange={handleChange} />
                                </Form.Group>
                            </Col>

                            <Col md={1}>

                                <Form.Group className="mb-12">
                                    <TituloCategoria id="NumeroPlazas">Nº Plazas</TituloCategoria>
                                    <Form.Control disabled={formData.plazasAgotadas} type="number" name="numPlazas" value={formData.numPlazas || ''} onChange={handleChange} />
                                </Form.Group>

                            </Col>

                            <Col md={1}>

                            </Col>

                            <Col md={2}>
                                <Form.Group style={{ paddingLeft: '10%' }} className="mb-12">
                                    <TituloCategoria>Plazas Agotadas </TituloCategoria>
                                    <EstiloSwitch
                                        type="switch"
                                        name="plazasAgotadas"
                                        checked={formData.plazasAgotadas || false}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group >
                                    <TituloCategoria>Activo </TituloCategoria>
                                    <EstiloSwitch
                                        name="activo"
                                        checked={formData.activo || false}
                                        onChange={handleChange}
                                        type="switch"
                                        id="activo"
                                    />
                                </Form.Group>
                                <Form.Group >
                                </Form.Group>
                            </Col>

                        </Row>
                    </Col>






                    <Row className="mt-4">

                        <Col md={4}>
                            <Form.Group>
                                <TituloCategoria id="vistaAdjuntos">¿Cómo desea subir el archivo? </TituloCategoria>
                                <Form.Select
                                    value={formData.vistaAdjuntos}
                                    name="vistaAdjuntos"
                                    onChange={handleChange}
                                >
                                    <option key="0" value="0">
                                        Subir URL
                                    </option>
                                    <option key="1" value="1">
                                        Subir PDF
                                    </option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        {formData.vistaAdjuntos === '0' && (
                            <>
                                <Col md={4}>
                                    <Form.Group className="mb-12">
                                        <TituloCategoria>Temario URL <span>*</span></TituloCategoria>
                                        <Form.Control
                                            type="name"
                                            name="temario_url"
                                            value={formData.temario_url || ''}
                                            onChange={handleChange}
                                        />
                                        <ErrorForm mensaje={camposRequeridos.temario_url} estadoAlerta={estadoCampoReque.temario_url} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    {categoriaHabilitado.anexo_pdf === true && (
                                        <>
                                            <Form.Group className="mb-12">
                                                <TituloCategoria>Anexo URL</TituloCategoria>
                                                <Form.Control
                                                    type="name"
                                                    name="anexo_url"
                                                    value={formData.anexo_url || ''}
                                                    onChange={handleChange}
                                                />
                                                <ErrorForm mensaje={camposRequeridos.anexo_url} estadoAlerta={estadoCampoReque.anexo_url} />
                                            </Form.Group>
                                        </>
                                    )}
                                </Col>
                            </>
                        )}


                        {formData.vistaAdjuntos === '1' && (
                            <>
                                <Col>
                                    <Form.Group className="mb-12">
                                        <TituloCategoria>Temario Adjunto<span>*</span></TituloCategoria>
                                        <Form.Control
                                            type="file"
                                            id="temario_pdf"
                                            accept=".pdf"
                                            max-file-size="3072"
                                            name="temario_pdf"
                                            onChange={handleChange}
                                        />
                                        <ErrorForm mensaje={camposRequeridos.temario_pdf} estadoAlerta={estadoCampoReque.temario_pdf} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    {categoriaHabilitado.anexo_pdf === true && (
                                        <>
                                            <Form.Group className="mb-12">
                                                <TituloCategoria>Anexo Adjunto</TituloCategoria>
                                                <Form.Control
                                                    type="file"
                                                    id="anexo_pdf"
                                                    accept=".pdf"
                                                    max-file-size="3072"
                                                    name="anexo_pdf"
                                                    onChange={handleChange}
                                                />
                                                <ErrorForm mensaje={camposRequeridos.anexo_pdf} estadoAlerta={estadoCampoReque.anexo_pdf} />
                                            </Form.Group>
                                        </>
                                    )}
                                </Col>
                            </>
                        )}

                        {previsualizacionTemarioPdf && (
                            <VisorPdf activo temario={true} pdfEntrada={previsualizacionTemarioPdf} />
                        )}
                        {categoriaHabilitado.anexo_pdf === true && previsualizacionAnexoPdf && (
                            <VisorPdf anexo={true} pdfEntrada={previsualizacionAnexoPdf} />
                        )}
                    </Row>


                    <Row className="mt-4">
                        <Col>
                            {previsualizacionImg ? (
                                <div>
                                    <TituloCategoria>Vista previa de la imagen:</TituloCategoria>
                                    <ContenedorEncabezado>
                                        <IconosGenerales
                                            alerta="true"
                                            id="delete"
                                            onClick={handleDelete}
                                        />
                                        <img src={previsualizacionImg} alt="Vista previa" style={{ width: '446px', height: '330px' }} />
                                    </ContenedorEncabezado>
                                </div>
                            ) : (
                                <div>
                                    <TituloCategoria>Vista previa de la imagen:</TituloCategoria>
                                    <img src={ImagenDefault} alt="Vista previa" style={{ width: '446px', height: '362px' }} />
                                </div>
                            )}
                        </Col>
                        <Col>
                            <Form.Group className="mb-3 mt-10">
                                <TituloCategoria>Adjuntar imagen del curso</TituloCategoria>
                                <Form.Control type="file" id='curso_img' accept=".jpg,.jpeg,.png,.webp" max-file-size="3072"
                                    name="curso_img" onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombreImg} estadoAlerta={estadoCampoReque.nombreImg} />
                            </Form.Group>
                            <ContenedorBotones>

                                <Boton
                                    convocatoria="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                    name='guardar_cambios_statico'
                                >
                                    Guardar
                                </Boton>

                                <Boton
                                    convocatoria="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Guardar y Salir
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/convocatoria/cursos"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Col>
                    </Row>
                    <InfoNiveles requisitos={requisitos} />
                </Container>

            </Form>

            {botonRenderClick ? 
                <DatosCorrectos envioActivado={formCompletado} />         
                :             
                <DatosCorrectos envioActivado={formCompletado} redirect={false} />
            }

            <DatosIncorrectos envioActivado={formCompletado} />
            <ServerNoCreoCurso envioActivado={errorEnviarForm.cursoDuplicado} />
            <ServerUrlAFExistente envioActivado={errorEnviarForm.refDuplicado} />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 20%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

const EstiloSwitch = styled(Form.Check)`
    .form-check-input {
        width: 3.5em !important;
        height: 1.8em !important;
        background-size: 1.5em 1.5em;
        background-color: white;
    }

    .form-check-input:checked {
        background-color: rgb(238, 128, 93) !important;
        border: #dee2e6;
        box-shadow: 0 0 0 .25rem rgba(238, 128, 93, .25);
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }

    .form-check-input:focus {
        border-color: #dee2e6 !important;
        box-shadow: none; 
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }
    
`

const ContenedorEncabezado = styled.div`
    width: 446px !important;
    height: auto !important;
    border: 1px solid #dee2e6;
`

export default FormEditarCurso;